import {IClassNameProps} from '@bem-react/core';
import React from 'react';
import {cnCollectionDetail} from '../CollectionDetail';
import {ICollectionDto} from '../../../../../common-code/interfaces/ICollectionDto';
import {useTranslation} from 'react-i18next';
import {ProjectItem} from '../../ProjectItem/ProjectItem';

export interface ICollectionDetailKitchensProps extends IClassNameProps {
    collection: ICollectionDto;
}

export const CollectionDetailKitchens: React.FC<ICollectionDetailKitchensProps> = ({collection}) => {
    const {t} = useTranslation();

    if (collection.kitchens === undefined ||
        (Object.values(collection.kitchens).length <= 0)) {
        return null;
    }
    return (
        <div className={cnCollectionDetail('Projects')}>
            <div className={cnCollectionDetail('Subtitle')}>
                {t('Кухонные комплекты')}:
            </div>
            <div className={cnCollectionDetail('ProjectsItems')}>
                {Object.values(collection.kitchens).map((kitchen) => {
                    return (
                        <ProjectItem className={cnCollectionDetail('Project')} key={kitchen.id} project={kitchen}/>
                    );
                })}
            </div>
        </div>
    );
}